module.exports = __webpack_public_path__ + "img/fruit-nectarines-190x100.65748d08.jpg";